// ── Pasos del flujo ───────────────────────────────────────────────────────────
export enum StockStep {
  Search = 0,
  Results = 1
}

// ── Modal de desambiguación ───────────────────────────────────────────────────
import { ModalSelectionOption } from '../modalSelection'

export interface ModalConfig {
  isOpen: boolean
  title: string
  description: string // texto plano — el JSX se construye en el componente
  highlightedValue: string // valor en negrita dentro de la descripción
  options: ModalSelectionOption[]
}

// ── Contexto que se pasa a la pantalla de resultados ─────────────────────────
export interface StockSearchContext {
  filterKey: 'location' | 'sku' // criterio de búsqueda usado
  locationActive?: boolean
  searchValue: string // valor ingresado por el usuario
  selectedLabel: string // bodega o marca seleccionada
  selectedKey: string // id de bodega o marca — para refetch por sku
  fefo?: boolean // solo para flujo sku
  vev?: boolean // solo para flujo sku
}
